module.exports = __webpack_public_path__ + "img/logo_inicio_2.f4840e4a.png";